import { useCommonData } from '@app/hooks/useCommonData';
import { cn } from '@app/libs/utils';

import LogoLoop from '../ui/LogoLoop';

interface PartnerSectionProps {
  className?: string;
}

export const PartnerSection: React.FC<PartnerSectionProps> = ({ className }) => {
  const { website } = useCommonData();
  const partners = website.partner;

  return (
    <>
      {partners && partners.length > 0 && (
        <section
          className={cn('w-full flex flex-col gap-10 items-center justify-center mb-20', className)}
        >
          <h2 className="text-3xl font-bold text-gray-900">Đối tác của chúng tôi</h2>
          <LogoLoop logos={partners} logoHeight={72} gap={100} />
        </section>
      )}
    </>
  );
};
